"use client"

import type React from "react"
import type { FieldMapping } from "../../../types/sync"

interface FieldMappingSectionProps {
  fieldMappings: FieldMapping[]
  onEdit: () => void
}

const FieldMappingSection: React.FC<FieldMappingSectionProps> = ({ fieldMappings, onEdit }) => (
  <div className="review-section mapping-section">
    <div className="section-header">
      <h2>Field Mappings ({fieldMappings.length})</h2>
      <button className="edit-button" onClick={onEdit}>
        Edit
      </button>
    </div>

    <div className="mapping-preview">
      {fieldMappings.length > 0 ? (
        <div className="mapping-table">
          <div className="mapping-headers">
            <div className="header-left">HubSpot Fields</div>
            <div className="header-right">Salesforce Fields</div>
          </div>

          <div className="mapping-rows">
            {fieldMappings.slice(0, 5).map((mapping, index) => (
              <div key={index} className="mapping-row">
                <div className="field-left">{mapping.hubspotField}</div>
                <div className="mapping-arrow">→</div>
                <div className="field-right">{mapping.salesforceField}</div>
              </div>
            ))}
            {fieldMappings.length > 5 && (
              <div className="mapping-row more-mappings">
                <div className="more-text">+{fieldMappings.length - 5} more mappings</div>
              </div>
            )}
          </div>
        </div>
      ) : (
        <div className="no-mappings">
          <p>No field mappings configured</p>
        </div>
      )}
    </div>
  </div>
)

export default FieldMappingSection
